import { createEventEmitter } from '@reckon-web/events';

export const gqlApiClientProviderEvents = createEventEmitter<{
  requestHeadersUpdate: (args: {
    requestHeaders: Record<string, string | undefined | null>;
  }) => void;
}>();
